export default {
  nav: {
    home: 'Accueil',
    categories: 'Catégories',
    guide: 'Guide',
    review: 'Avis',
    shipping: 'Livraison',
    safety: 'Sécurité',
    faq: 'FAQ',
    cta: 'Voir le site principal',
    shoppingGuide: 'Guide d\'achat',
  },
  hero: {
    badge: 'Mis à jour pour 2026 · Ressource indépendante',
    title: 'AllChinaBuy Spreadsheet — Trouvez produits, liens et QC plus vite',
    subtitle:
      'Explorez les dernières ressources du tableur AllChinaBuy, les trouvailles de produits, les liens utiles, les infos QC, les guides d\'achat et les ressources de livraison en un seul endroit.',
    ctaPrimary: 'AllChinaBuy Spreadsheet',
    ctaSecondary: 'Acheter maintenant',
    searchPlaceholder: 'Rechercher produits, catégories ou guides...',
  },
  categories: {
    title: 'Catégories populaires',
    subtitle: 'Accédez directement aux produits et liens dont vous avez besoin sur le tableur principal.',
    dropdownLabel: 'Parcourir par catégorie',
    dropdownPlaceholder: 'Choisir une catégorie',
    visit: 'Voir sur le site principal',
  },
  cat: {
    shoes: 'Chaussures',
    hoodies: 'Hoodies / Sweats',
    tshirts: 'T-Shirts',
    jackets: 'Vestes',
    pants: 'Pantalons / Shorts',
    headwear: 'Couvre-chefs',
    sets: 'Ensembles',
    underwear: 'Sous-vêtements',
    jersey: 'Maillot',
    accessories: 'Accessoires',
    bags: 'Sacs',
    belts: 'Ceintures',
    perfumes: 'Parfums',
    other: 'Autres articles',
  },
  info: {
    sectionTitle: 'Tout savoir sur le AllChinaBuy Spreadsheet',
    whatTitle: 'Qu\'est-ce que le AllChinaBuy Spreadsheet ?',
    whatBody:
      'Le tableur AllChinaBuy est une collection organisée de trouvailles de produits, de liens fonctionnels, de photos QC et de notes de livraison réunies dans une seule feuille. Au lieu de fouiller des fils interminables, les acheteurs ouvrent un seul tableur pour voir des articles — chaussures, hoodies, t-shirts, vestes, sacs et plus — chaque ligne indiquant le produit, son lien, sa gamme de prix et son statut de contrôle qualité.',
    howTitle: 'Comment ça marche',
    howBody:
      'Ouvrez le tableur, choisissez une catégorie dans le menu déroulant ou la grille, puis accédez à l\'article voulu. Chaque produit renvoie directement au site principal pour vérifier les détails, comparer les options et passer commande en quelques clics. La mise en page est pensée pour la vitesse : trouver, vérifier la photo QC, copier le lien, terminé.',
    reviewTitle: 'Pourquoi les acheteurs l\'adorent',
    reviewBody:
      'Les utilisateurs reviennent sans cesse au tableur car il fait gagner des heures de recherche et supprime les incertitudes. La version la plus utile combine de vrais retours d\'acheteurs et des photos QC à jour, pour savoir ce que vous achetez avant de payer. C\'est un outil de recherche, pas une boutique — l\'achat final se fait sur le site principal.',
    shippingTitle: 'Coût de livraison & entrepôt',
    shippingBody:
      'Le coût de livraison dépend de l\'article, de son poids et de la ligne de livraison choisie. Le tableur regroupe les articles par catégorie pour comparer des produits similaires et planifier une commande groupée afin de réduire le coût par article. Consultez les sections entrepôt et livraison pour les méthodes actuelles et les astuces d\'économie.',
    qcTitle: 'QC & inspection des produits',
    qcBody:
      'Le contrôle qualité est l\'étape qui protège votre commande. Cherchez des tableurs qui incluent des photos QC, des mesures et des notes du vendeur avant de vous engager. Si une fiche n\'a aucune donnée QC, traitez-la avec prudence et demandez d\'abord des photos au vendeur.',
    safetyTitle: 'Centre de sécurité',
    safetyBody:
      'Ceci est une ressource d\'information indépendante, non affiliée à AllChinaBuy et non exploitée par lui. Méfiez-vous des faux tableurs et des liens de phishing. N\'utilisez que les liens provenant du site principal et ne saisissez jamais vos identifiants ou données de paiement sur des pages inconnues.',
  },
  article: {
    badge: 'Guide complet',
    title: 'AllChinaBuy Spreadsheet : guide complet des trouvailles, liens et QC',
    desc:
      'Un guide complet sur ce qu\'est le tableur AllChinaBuy, ce qu\'il contient, comment l\'utiliser et comment vérifier les produits en toute sécurité avant de commander.',
    cta: 'Lire le guide complet',
    readTime: '8 min de lecture',
    updated: 'Dernière mise à jour',
  },
  faq: {
    title: 'Questions fréquentes',
    q1: 'Le AllChinaBuy Spreadsheet est-il gratuit ?',
    a1: 'Le tableur est une ressource d\'information gratuite. Vous pouvez parcourir les catégories et les liens ici, et l\'achat final se fait sur le site principal.',
    q2: 'Ce site est-il affilié à AllChinaBuy ?',
    a2: 'Non. Ceci est une ressource d\'information indépendante. Nous ne sommes pas affiliés à AllChinaBuy et ne sommes pas exploités par lui.',
    q3: 'Comment vérifier le QC d\'un produit ?',
    a3: 'Cherchez les photos QC, les mesures et les notes du vendeur dans la fiche. Si un produit n\'a aucune donnée QC, demandez des photos au vendeur avant de commander.',
    q4: 'Comment réduire les frais de livraison ?',
    a4: 'Regroupez plusieurs articles dans une même commande, choisissez une ligne de livraison adaptée et comparez des produits similaires dans la même catégorie avant de vous engager.',
    q5: 'Les liens des produits sont-ils sûrs ?',
    a5: 'N\'utilisez que les liens provenant du site principal. Évitez les liens tiers ou raccourcis, et ne saisissez jamais vos identifiants ou données de paiement sur des pages inconnues.',
  },
  footer: {
    about:
      'Ressource d\'information indépendante pour les trouvailles, liens, photos QC et guides de livraison du AllChinaBuy Spreadsheet. Nous ne sommes pas affiliés à AllChinaBuy et ne sommes pas exploités par lui.',
    linksTitle: 'Liens rapides',
    categoriesTitle: 'Catégories',
    disclaimer:
      'Ceci est une ressource d\'information indépendante, non affiliée à AllChinaBuy et non exploitée par lui.',
    rights: 'Tous droits réservés.',
  },
  pillar: {
    title: 'Guides piliers & analyses',
    subtitle: 'Des guides originaux et approfondis pour acheter plus intelligemment et en toute sécurité avec le AllChinaBuy Spreadsheet.',
    read: 'Lire le guide',
  },
  guide: {
    notFound: 'Guide introuvable',
    notFoundDesc: 'Le guide que vous cherchez n\'existe pas. Retournez à l\'accueil pour parcourir tous les guides.',
    ctaTitle: 'Prêt à parcourir les dernières trouvailles ?',
    ctaDesc: 'Explorez chaque catégorie et accédez directement aux produits du site principal.',
    related: 'Guides associés',
  },
  common: {
    explore: 'Explorer',
    learnMore: 'En savoir plus',
    backHome: 'Retour à l\'accueil',
    readArticle: 'Lire le guide',
  },
};